(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabFleetsManageObjectController', TabFleetsManageObjectController);

    TabFleetsManageObjectController.$inject = ['$state', '$scope', 'entity', 'TabFleets', 'TabObjects', 'AlertService'];

    function TabFleetsManageObjectController($state, $scope, entity, TabFleets, TabObjects, AlertService) {
        var vm = this;

        vm.fleets = [];

        vm.fleet1 = [];
        vm.type1 = [];
        vm.fleet2 = [];
        vm.type2 = [];
        vm.fleetFilters = {
            name:     '',
            category: 'all',
            objectUniqueCode: '',
            type: 'ALL'
        };
        vm.fleet2Filters = {
            name:     '',
            category: 'all',
            objectUniqueCode: '',
            type: 'ALL'
        };

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.fleet1 = entity;

                TabFleets.query(onSuccess, onError);

                function onSuccess(data){
                    for(var i = 0; i < data.length; i++){
                        vm.fleets.push(data[i]);
                        if(vm.fleet1.id == vm.fleets[i].id){
                            vm.fleets[i].selected = true;
                        } else {
                            vm.fleets[i].selected = false;
                        }
                    }
                }

                function onError(){}

                getObject(vm.fleet1, vm.type1);
            });
        }

        vm.getIndex = function (fleet) {
            for(var i = 0; i < vm.fleets.length; i++){
                if(fleet.id == vm.fleets[i].id)
                    return i;
            }
        };

        vm.change = function (fleet, type){
            for(var i = 0; i < vm.fleets.length; i++){
                if(vm.fleet1.id == vm.fleets[i].id || vm.fleet2.id == vm.fleets[i].id){
                    vm.fleets[i].selected = true;
                } else {
                    vm.fleets[i].selected = false;
                }
            }
            getObject(fleet, type);
        };

        vm.moveObj = function(obj,origin,destination) {
            //check if selected fleet are not the same
            if(destination != undefined){
                if (origin.id != destination.id) {
                    var index = origin.fleetList.findIndex(function(elem){
                        return (elem.id == obj.id);
                    });
                    origin.fleetList.splice(index,1);
                    destination.fleetList.unshift(obj);

                    obj.fleet.domains = destination.domains;
                    obj.fleet.entityId = destination.entityId;
                    obj.fleet.files = destination.files;
                    obj.fleet.fleetDescription = destination.fleetDescription;
                    obj.fleet.fleetName = destination.fleetName;
                    obj.fleet.id = destination.id;
                    obj.fleet.objectClass = destination.objectClass;
                    obj.fleet.otherMetrics = destination.otherMetrics;
                    obj.fleet.users = destination.users;
                    TabObjects.update(obj, onSuccessUpdate, onErrorUpdate);

                    function onSuccessUpdate() {}

                    function onErrorUpdate() {}
                }
            } else AlertService.error("No destination fleet has been selected")
        };

        function getObject(fleet, type) {
            var body = {
                id: fleet.id,
                onlyUpdate: false,
                onlyOnline: false,
                page: vm.page,
                size: 1000
            };
            TabObjects.byFleet(body, onSuccessObj, onErrorObj);

            function onSuccessObj(data) {
                vm.fleets[vm.getIndex(fleet)].fleetList = data.tabObjectsList;
                getType(vm.fleets[vm.getIndex(fleet)].fleetList, type);
            }

            function onErrorObj() {}
        }

        function getType(listObj, type){
            type.length = 0;
            for(var i = 0; i < listObj.length; i++){
                type.push(listObj[i].objectType.objectTypeName);
            }
            type.sort();
            for(var i = 1; i < type.length;){
                if(type[i-1] ===  type[i]){
                    type.splice(i, 1);
                } else {
                    i++;
                }
            }
            type.push("ALL");
        }
    }
})();
